import { createFileRoute, redirect } from '@tanstack/react-router';

import type { RouterContext } from '@shared/config/router-context';
import { canAccessErpSync } from '@shared/lib';
import { ErpSyncShell } from '@widgets/erp-sync-shell';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync')({
  beforeLoad: ({ context, params }) => {
    const { auth, ability } = context as RouterContext;

    if (auth.isLoading || !auth.isAuthenticated) {
      return;
    }

    if (!canAccessErpSync(ability, auth.user?.systemRole ?? null)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/$locale/unauthorized',
        params: { locale: params.locale },
      });
    }
  },
  component: ErpSyncLayoutRoute,
});

function ErpSyncLayoutRoute() {
  const { locale } = Route.useParams();
  return <ErpSyncShell locale={locale} />;
}
